import React from 'react';
import { withStyles } from '@mui/styles';

import { connect } from 'react-redux';

import { Table, TableRow, TableBody, TableHead, TableCell } from '@mui/material';

import CommonStyles from '../../common/CommonStyles';
import ComponentWrapper from '../../common/ComponentWrapper';

import Cron from './components/Cron';
import NewCron from './components/NewCron';
import { getAllRstsAsArray } from '../../utils';

const styles = {
  ...CommonStyles,
};

const cronTimeKeys = [
  { value: '1', title: '1h ago' },
  { value: '2', title: '2h ago' },
  { value: '3', title: '3h ago' },
  { value: '4', title: '4h ago' },
  { value: '5', title: '5h ago' },
  { value: '6', title: '6h ago' },
  { value: '7', title: '7h ago' },
  { value: '8', title: '8h ago' },
  { value: '9', title: '9h ago' },
  { value: '10', title: '10h ago' },
  { value: '11', title: '11h ago' },
  { value: '12', title: '12h ago' },
  { value: '13', title: '13h ago' },
  { value: '14', title: '14h ago' },
  { value: '15', title: '15h ago' },
  { value: '16', title: '16h ago' },
  { value: '17', title: '17h ago' },
  { value: '18', title: '18h ago' },
  { value: '19', title: '19h ago' },
  { value: '20', title: '20h ago' },
  { value: '21', title: '21h ago' },
  { value: '22', title: '22h ago' },
  { value: '23', title: '23h ago' },
  { value: '24', title: '24h ago' },
];

class CronPage extends ComponentWrapper {
  state = {
    crons: [],
    restrictionsOptions: [],
    newCron: {
      action: 'trpl_del',
      pid: '',
      strategy: 'create_time',
      value: { units: 'h', time: '1' },
      period: { units: 'm', time: '20' },
    },
  };

  componentDidMount() {
    document.title="Cron | Milkyweb";

    this.get({
      url: '/get_jel?type=["cron"]',
      cb: (res) => {
        const { light_meta_and_ops } = this.props;

        const restrictionsOptions = [];
        const crons = res.cron || [];
        const rsts = getAllRstsAsArray(light_meta_and_ops);

        for (const rst of rsts) {
          restrictionsOptions.push({
            label: `[${rst.id}] ${rst.title}`,
            value: rst.id,
          });
        }

        this.setState({ restrictionsOptions, crons });
      },
    });
  }

  onNewCronFieldChange = (key, value) => {
    const { newCron } = this.state;

    newCron[key] = value;

    this.setState({ newCron });
  };

  addNewCronClick = () => {
    const { newCron } = this.state;

    this.postWithData({
      url: '/rest/upd_jel?type=cron',
      data: newCron,
      cb: (res) => {
        if (res.cron) {
          const { crons } = this.state;

          crons.push(res.cron);

          const newCron = {
            action: 'trpl_del',
            pid: '',
            strategy: 'create_time',
            value: { units: 'h', time: '1' },
            period: { units: 'm', time: '20' },
          };

          this.setState({ crons, newCron });
        }
      },
    });
  };

  saveCronClick = (cron, cronIndex) => {
    this.postWithData({
      url: '/rest/upd_jel?type=cron',
      data: cron,
      cb: (res) => {
        const { cron } = res;
        const { crons } = this.state;

        crons[cronIndex] = cron;

        this.setState({ crons });
      },
    });
  };

  deleteCronClick = (cronIndex, id) => {
    this.get({
      url: `/del_jel?id=${id}`,
      cb: () => {
        const { crons } = this.state;

        crons.splice(cronIndex, 1);

        this.setState({ crons });
      },
    });
  };

  onCronFieldChange = (cronIndex, key, value) => {
    const { crons } = this.state;

    crons[cronIndex][key] = value;

    this.setState({ crons });
  };

  render() {
    const { classes } = this.props;
    const { restrictionsOptions, newCron, crons } = this.state;

    return (
      <div className={classes.container}>
        <Table
          style={{
            background: '#fff',
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>Action</TableCell>
              <TableCell>Predicate</TableCell>
              <TableCell>Strategy</TableCell>
              <TableCell>Value</TableCell>
              <TableCell>Period</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {crons.map((cron, cronIndex) => {
              return (
                <Cron
                  cron={cron}
                  key={cronIndex}
                  classes={classes}
                  cronIndex={cronIndex}
                  cronTimeKeys={cronTimeKeys}
                  saveCronClick={this.saveCronClick}
                  deleteCronClick={this.deleteCronClick}
                  restrictionsOptions={restrictionsOptions}
                  onCronFieldChange={this.onCronFieldChange}
                />
              );
            })}

            <NewCron
              newCron={newCron}
              classes={classes}
              cronTimeKeys={cronTimeKeys}
              addNewCronClick={this.addNewCronClick}
              restrictionsOptions={restrictionsOptions}
              onNewCronFieldChange={this.onNewCronFieldChange}
            />
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default connect((state) => ({
  light_meta_and_ops: state.meta.light_meta_and_ops
}))(withStyles(styles)(CronPage));
